import { DateTime, Duration } from "luxon";
export interface MasterPlanLocationWebEntity{
    id: string;
    locationId: string;
    name: string;
    latitude: number;
    longitude: number;
    address: string;
    postalCode: string;
    city: string;
    country: string;
    locationType: number;
    planContainerId: string;
    segment:string;
    stopTime :Duration;
    productsAdditionalInfo? : ProductsForPlanWebEntity[]
}

export interface ProductsForPlanWebEntity {
    productId?: string;
    productName?: string;
    productAdditionalInfo?: string;
    daoLocationKey?: string;
    productKeyMapping?: boolean;
}